// extracted by mini-css-extract-plugin
export default {"infoContainer":"CardBody_infoContainer__ZdGlM"};